import {Injectable} from '@angular/core';
import {IVehicleMake, IVehicleModel} from '@shared/interfaces';
import {Store} from '@ngxs/store';
import {Database, ref, get, child} from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class VehicleService {

  constructor(private store: Store, private db: Database) {
  }

  async getMakes(): Promise<IVehicleMake[]> {
    const path = `vehicles/makes`;
    const dbRef = ref(this.db, path);
    return (await get(dbRef)).val();
  }

  async getModelsByMake(make: string): Promise<{ [k: string]: IVehicleModel[] }> {
    const path = `vehicles/models`;
    const dbRef = ref(this.db, path);
    return (await get(child(dbRef, make))).val();
  }

  async getUpdatedAt(): Promise<string | number> {
    const path = `vehicles/updatedAt`;
    const dbRef = ref(this.db, path);
    return (await get(dbRef)).val();
  }
}
